import React, { useMemo } from 'react';
import { bool } from 'prop-types';
import { injectIntl, intlShape } from '../../util/reactIntl';
import { Form as FinalForm } from 'react-final-form';
import classNames from 'classnames';
import { Form, PrimaryButton, FieldTextInput, ErrorMessage } from '../../components';
import { composeValidators, emailFormatValid, required } from '../../util/validators';

import css from './ContactForm.module.css';

const ContactFormComponent = props => {
  const { rootClassName, className, error, intl, ...rest } = props;

  const messages = useMemo(
    () => ({
      firstNameLabel: intl.formatMessage({ id: 'General.firstName' }),
      firstNamePlaceholder: intl.formatMessage({ id: 'General.firstNamePlaceholder' }),
      lastNameLabel: intl.formatMessage({ id: 'General.lastName' }),
      lastNamePlaceholder: intl.formatMessage({ id: 'General.lastNamePlaceholder' }),
      emailLabel: intl.formatMessage({ id: 'General.email' }),
      emailPlaceholder: intl.formatMessage({ id: 'General.emailPlaceholder' }),
      emailInvalid: intl.formatMessage({ id: 'General.emailInvalid' }),
      messageLabel: intl.formatMessage({ id: 'General.message' }),
      messagePlaceholder: intl.formatMessage({ id: 'General.messagePlaceholder' }),
      requiredField: intl.formatMessage({ id: 'General.requiredField' }),
      sendMessage: intl.formatMessage({ id: 'General.sendMessage' }),
    }),
    [intl]
  );

  const classes = useMemo(() => classNames(rootClassName || css.root, className), [
    className,
    rootClassName,
  ]);

  return (
    <FinalForm
      {...rest}
      render={fieldRenderProps => {
        const { handleSubmit, inProgress, invalid, ready } = fieldRenderProps;

        return (
          <Form className={classes} onSubmit={handleSubmit}>
            <FieldTextInput
              className={css.field}
              type="text"
              id="firstName"
              name="firstName"
              autoComplete="given-name"
              label={messages.firstNameLabel}
              placeholder={messages.firstNamePlaceholder}
              validate={required(messages.requiredField)}
            />
            <FieldTextInput
              className={css.field}
              type="text"
              id="lastName"
              name="lastName"
              autoComplete="family-name"
              label={messages.lastNameLabel}
              placeholder={messages.lastNamePlaceholder}
              validate={required(messages.requiredField)}
            />
            <FieldTextInput
              className={css.field}
              type="email"
              id="email"
              name="email"
              autoComplete="email"
              label={messages.emailLabel}
              placeholder={messages.emailPlaceholder}
              validate={composeValidators(
                required(messages.requiredField),
                emailFormatValid(messages.emailInvalid)
              )}
            />
            <FieldTextInput
              className={css.field}
              type="textarea"
              id="message"
              name="message"
              label={messages.messageLabel}
              placeholder={messages.messagePlaceholder}
              validate={required(messages.requiredField)}
            />
            <PrimaryButton
              className={css.button}
              inProgress={inProgress}
              disabled={invalid || inProgress}
              ready={ready}
            >
              {messages.sendMessage}
            </PrimaryButton>
            {error && <ErrorMessage />}
          </Form>
        );
      }}
    />
  );
};

ContactFormComponent.defaultProps = { inProgress: false, ready: false };

ContactFormComponent.propTypes = {
  inProgress: bool,
  ready: bool,

  // from injectIntl
  intl: intlShape.isRequired,
};

const ContactForm = injectIntl(ContactFormComponent);

export default ContactForm;
